import { AttributeDetailRenderer, AttributeColumnRenderer } from '@leverege/ui-attributes';
const getAttributeRendererValueVariant = renderer => {
  if (renderer instanceof AttributeColumnRenderer) {
    return renderer.column.cell.variant;
  }
  if (renderer instanceof AttributeDetailRenderer) {
    return renderer.detail.value.variant;
  }
  return null;
};
export default {
  getAttributeRendererValueVariant
};